export function pluralize<T>(entries: T[] | number | undefined, single: string, plural?: string): string {
  if (typeof entries === 'number' ? entries === 1 : entries?.length === 1) return single
  return plural ?? `${single}s`
}
